import "amazon-connect-streams";
import type { ConferenceParticipant } from "@/sdk";

import { UnreachableError } from "@/shared-utils";

function stateToTypeAndStatusProps({ type }: connect.ConnectionState) {
    switch (type) {
        case connect.ConnectionStateType.INIT:
            return { type: "pending", status: "queued" } as const;
        case connect.ConnectionStateType.CONNECTING:
            return { type: "pending", status: "initiated" } as const;
        case connect.ConnectionStateType.CONNECTED:
        case connect.ConnectionStateType.HOLD:
            return { type: "active", status: "in-progress" } as const;
        case connect.ConnectionStateType.DISCONNECTED:
            return { type: "inactive", status: "completed" } as const;
        case connect.ConnectionStateType.SILENT_MONITOR:
        case connect.ConnectionStateType.BARGE:
            throw new Error(`voice connect state type not supported: ${type}`);
        default:
            throw new UnreachableError(type);
    }
}

export default function voiceConnectionToParticipant(voiceConnection: connect.VoiceConnection): ConferenceParticipant {
    const state = voiceConnection.getState();
    return {
        ...stateToTypeAndStatusProps(state),
        participantCallId: voiceConnection.connectionId,
        participantName: voiceConnection.getQuickConnectName() ?? voiceConnection.getEndpoint().phoneNumber,
        muted: voiceConnection.isMute(),
        hold: voiceConnection.isOnHold() ? { since: state.timestamp.valueOf() } : undefined,
        quickConnectName: voiceConnection.getQuickConnectName() ?? undefined,
    };
}
